import { ChangeDetectionStrategy, Component } from '@angular/core';
import { SectionHeaderComponent } from '@app/widgets/components';
import { TuiIcon } from '@taiga-ui/core';

@Component({
  selector: 'app-app-store-publishing-features-section',
  imports: [SectionHeaderComponent, TuiIcon],
  templateUrl: './app-store-publishing-features-section.component.html',
  styleUrl: './app-store-publishing-features-section.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class AppStorePublishingFeaturesSectionComponent {}
